/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2026.1.22",
    versionName: "0.2.0-nightly.2026.1.22",
    versionChannel: "nightly",
    buildDate: "2026-01-22T00:08:18.433Z",
    commitHash: "d5ebae49fff2b61c06328243532e2cae8c95efb3",
};
